import { pageResolver } from '@/core/component-resolver.service';
import B2CContentPage from './B2CContentPage.vue';

// Content pages
pageResolver.register('B2CContentPageViewModel', B2CContentPage);
pageResolver.register('B2CPublicContentPageViewModel', B2CContentPage);
